/* ================================================================
   YOCHAMIDA — Theme JavaScript
   Composants : Menu Mobile · Avant/Après Slider · Filtre Console · Header Scroll
   Vanilla JS uniquement — aucune dépendance externe
   ================================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------------
     I18N — textes générés côté JS.
     window.YC_LOCALE est posé par theme.liquid ('fr' ou autre).
     YCT('cle') renvoie le FR sur la boutique française, l'EN ailleurs.
  ---------------------------------------------------------------- */
  var YC_IS_FR = (window.YC_LOCALE || 'fr').toLowerCase().indexOf('fr') === 0;
  var YC_ROOT  = (window.YC_ROOT || '/');
  var YC_STR = {
    countdown_over:  ['Terminé', 'Ended'],
    add_to_cart:     ['Ajouter au panier', 'Add to cart'],
    add_short:       ['Ajouter', 'Add'],
    sold_out:        ['Épuisé', 'Sold out'],
    free_ship_ok:    ['🎉 <strong>Livraison offerte</strong> débloquée !', '🎉 <strong>Free shipping</strong> unlocked!'],
    free_ship_left:  ['Plus que <strong>{n}</strong> pour la livraison offerte', 'Only <strong>{n}</strong> away from free shipping'],
    qty_minus:       ['Diminuer', 'Decrease'],
    qty_plus:        ['Augmenter', 'Increase'],
    remove:          ['Retirer', 'Remove'],
    all_grades:      ['S / A / B', 'S / A / B']
  };
  function YCT(key, vars) {
    var e = YC_STR[key];
    var out = e ? (YC_IS_FR ? e[0] : e[1]) : key;
    if (vars) { for (var k in vars) { out = out.split('{' + k + '}').join(vars[k]); } }
    return out;
  }
  var YC_MONEY_LOCALE = YC_IS_FR ? 'fr-FR' : 'en-IE';

  /* ----------------------------------------------------------------
     MENU MOBILE
     Bouton hamburger ↔ panneau latéral + overlay + trap focus
  ---------------------------------------------------------------- */
  function initMobileMenu() {
    const toggle  = document.querySelector('.mobile-menu-toggle');
    const menu    = document.querySelector('.mobile-menu');
    const overlay = document.querySelector('.mobile-menu-overlay');
    if (!toggle || !menu) return;

    function open() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      overlay && overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      /* Focus sur le premier lien du menu */
      const firstLink = menu.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }

    function close() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      overlay && overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
      toggle.getAttribute('aria-expanded') === 'true' ? close() : open();
    });

    overlay && overlay.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        close();
        toggle.focus();
      }
    });
  }

  /* ----------------------------------------------------------------
     AVANT / APRÈS SLIDER
     Utilise un <input[range]> transparent superposé.
     La propriété clip-path sur .ba-after suit la valeur du slider.
  ---------------------------------------------------------------- */
  function initBeforeAfterSliders() {
    document.querySelectorAll('[data-comparison]').forEach(function (comp) {
      const slider  = comp.querySelector('.ba-slider');
      const afterEl = comp.querySelector('.ba-after');
      const handle  = comp.querySelector('.ba-handle');
      if (!slider || !afterEl) return;

      function update(pct) {
        const right = 100 - pct;
        afterEl.style.clipPath = 'inset(0 ' + right + '% 0 0)';
        if (handle) handle.style.left = pct + '%';
      }

      /* Input range (clavier + pointeur) */
      slider.addEventListener('input', function () {
        update(parseFloat(this.value));
      });

      /* Drag souris / touch directement sur le conteneur */
      const container = comp.querySelector('.ba-container');
      if (!container) return;

      let dragging = false;

      function getClientX(e) {
        return e.touches ? e.touches[0].clientX : e.clientX;
      }
      function startDrag() { dragging = true; }
      function endDrag()   { dragging = false; }
      function onDrag(e) {
        if (!dragging) return;
        const rect = container.getBoundingClientRect();
        const pct  = Math.min(100, Math.max(0, ((getClientX(e) - rect.left) / rect.width) * 100));
        slider.value = pct;
        update(pct);
      }

      container.addEventListener('mousedown',  startDrag);
      container.addEventListener('touchstart', startDrag, { passive: true });
      document.addEventListener('mouseup',    endDrag);
      document.addEventListener('touchend',   endDrag);
      document.addEventListener('mousemove',  onDrag);
      document.addEventListener('touchmove',  onDrag, { passive: true });

      /* Position initiale : 50% */
      update(50);
    });
  }

  /* ----------------------------------------------------------------
     FILTRE PAR CONSOLE
     Onglets → masque/affiche les cartes via data-categories.
     Pas de rechargement de page.
  ---------------------------------------------------------------- */
  function initConsoleFilter() {
    document.querySelectorAll('.filter-tabs').forEach(function (tabList) {
      const tabs    = Array.from(tabList.querySelectorAll('.filter-tab'));
      const section = tabList.closest('.console-filter');
      if (!section) return;
      const cards = Array.from(section.querySelectorAll('.filter-card'));

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const filter = this.dataset.filter;

          /* Mise à jour des onglets */
          tabs.forEach(function (t) {
            t.classList.remove('filter-tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          this.classList.add('filter-tab--active');
          this.setAttribute('aria-selected', 'true');

          /* Affichage/masquage des cartes */
          cards.forEach(function (card) {
            const cats = (card.dataset.categories || '').split(',');
            const show = filter === 'all' || cats.includes(filter);
            card.setAttribute('data-visible', show ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ----------------------------------------------------------------
     HEADER SCROLL
     Ajoute .is-scrolled au header sticky quand on scrolle > 10px
     (utilisé pour l'ombre bleue subtile dans le CSS)
  ---------------------------------------------------------------- */
  function initStickyHeader() {
    const header = document.querySelector('.site-header--sticky');
    if (!header) return;

    let ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          header.classList.toggle('is-scrolled', window.scrollY > 10);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ----------------------------------------------------------------
     URGENCY BAR — "X personnes regardent" + sticky ATC mobile
  ---------------------------------------------------------------- */
  function initProductUrgency() {
    /* Compteur "X personnes regardent" — fluctue légèrement pour paraître vivant */
    var counter = document.querySelector('.viewers-count');
    if (counter) {
      var base = parseInt(counter.dataset.base, 10) || 3;
      var current = base;

      function updateViewers() {
        var delta = Math.random() < 0.5 ? -1 : 1;
        current = Math.max(2, Math.min(12, current + delta));
        counter.textContent = current;
      }

      counter.textContent = current;
      setInterval(updateViewers, 7000 + Math.random() * 6000);
    }

    /* Sticky ATC — apparaît quand le bouton ATC natif sort du viewport */
    var stickyAtc = document.getElementById('sticky-atc-mobile');
    if (!stickyAtc) return;

    var nativeAtc = document.querySelector('.product-form__submit, [name="add"]');
    if (!nativeAtc) return;

    var atcTicking = false;
    window.addEventListener('scroll', function () {
      if (atcTicking) return;
      atcTicking = true;
      requestAnimationFrame(function () {
        var rect   = nativeAtc.getBoundingClientRect();
        var hidden = rect.bottom < 0 || rect.top > window.innerHeight;
        stickyAtc.classList.toggle('is-visible', hidden);
        stickyAtc.setAttribute('aria-hidden', String(!hidden));
        atcTicking = false;
      });
    }, { passive: true });
  }

  /* ----------------------------------------------------------------
     POPUP NEWSLETTER — délai + exit intent + dismiss persistant
  ---------------------------------------------------------------- */
  function initNewsletterPopup() {
    var popup     = document.getElementById('newsletter-popup');
    if (!popup) return;

    var delaySec  = parseInt(popup.dataset.delay, 10) || 8;
    var exitIntent = popup.dataset.exitIntent === 'true';
    var storageKey = 'yc-popup-dismissed';

    /* Ne pas afficher si déjà fermé cette session OU dans les 7 derniers jours */
    try {
      if (sessionStorage.getItem(storageKey)) return;
      var dismissed = localStorage.getItem(storageKey);
      if (dismissed && Date.now() - parseInt(dismissed, 10) < 7 * 86400000) return;
    } catch (e) {}

    var popupHideTimer = null;
    function openPopup() {
      clearTimeout(popupHideTimer);
      popup.removeAttribute('hidden');
      popup.setAttribute('aria-hidden', 'false');
      void popup.offsetWidth; /* reflow : transition depuis l'état fermé */
      popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      clearTimeout(popupHideTimer);
      popupHideTimer = setTimeout(function() { popup.setAttribute('hidden', ''); }, 400);
      try {
        sessionStorage.setItem(storageKey, '1');
        localStorage.setItem(storageKey, String(Date.now()));
      } catch (e) {}
    }

    /* Fermeture via boutons ou overlay */
    popup.querySelectorAll('[data-close-popup]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    /* Succès formulaire */
    var form = popup.querySelector('[data-popup-form]');
    if (form) {
      form.addEventListener('submit', function () {
        setTimeout(closePopup, 1200);
      });
    }

    /* ── Séquençage : jamais par-dessus un autre overlay ──
       On évite d'empiler la popup sur un autre panneau. Deux cas distincts :
       - Panneau piloté par l'utilisateur (panier, filtres, menu) : il se
         ferme vite → on attend qu'il soit refermé.
       - Bannière cookies Shopify : beaucoup de visiteurs l'ignorent sans
         cliquer. On lui laisse un court DÉLAI DE GRÂCE pour ne pas empiler,
         puis on ouvre quand même — sinon la popup ne sort jamais pour eux. */
    var BANNER_GRACE_MS = 6000;
    var bannerBlockedSince = null;

    /* La bannière cookies Shopify est en position:fixed → son offsetParent
       vaut toujours null, un test offsetParent ne la détecte donc jamais.
       On vérifie sa visibilité réelle : rendue, dimensionnée, à l'écran. */
    function cookieBannerOnScreen() {
      var b = document.getElementById('shopify-pc__banner');
      if (!b) return false;
      var cs = getComputedStyle(b);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05) return false;
      var r = b.getBoundingClientRect();
      if (r.width < 2 || r.height < 2) return false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var vw = window.innerWidth || document.documentElement.clientWidth;
      return r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
    }

    function overlayBlocked() {
      /* Panneau utilisateur ouvert (verrouille le scroll du body) : on patiente. */
      if (document.body.style.overflow === 'hidden') return true;

      if (!cookieBannerOnScreen()) { bannerBlockedSince = null; return false; }

      /* Bannière cookies visible : bloquée seulement le temps du délai de grâce. */
      if (bannerBlockedSince === null) bannerBlockedSince = Date.now();
      return (Date.now() - bannerBlockedSince) < BANNER_GRACE_MS;
    }

    function tryOpen() {
      if (overlayBlocked()) {
        /* Retente vite : la popup s'ouvre dès que la bannière est fermée
           (ou dès la fin du délai de grâce si elle est ignorée). */
        delayTimer = setTimeout(tryOpen, 1500);
        return;
      }
      openPopup();
    }

    /* Déclenchement : délai */
    var delayTimer = setTimeout(tryOpen, delaySec * 1000);

    /* Déclenchement : exit intent (souris sort par le haut) */
    if (exitIntent) {
      document.addEventListener('mouseleave', function handler(e) {
        if (e.clientY < 20 && !popup.classList.contains('is-open') && !overlayBlocked()) {
          clearTimeout(delayTimer);
          openPopup();
          document.removeEventListener('mouseleave', handler);
        }
      });
    }
  }

  /* ----------------------------------------------------------------
     BARRE D'ANNONCE — dismiss + compte à rebours
  ---------------------------------------------------------------- */
  function initAnnouncementBar() {
    document.querySelectorAll('.ab-close').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var barId = this.dataset.barId;
        var bar   = document.getElementById('announcement-bar-' + barId);
        if (!bar) return;
        bar.style.maxHeight = bar.offsetHeight + 'px';
        bar.style.overflow  = 'hidden';
        bar.style.transition = 'max-height 300ms ease, opacity 300ms ease';
        requestAnimationFrame(function () {
          bar.style.maxHeight = '0';
          bar.style.opacity   = '0';
        });
        bar.addEventListener('transitionend', function () { bar.remove(); }, { once: true });
        try { sessionStorage.setItem('yc-bar-dismissed-' + barId, '1'); } catch (e) {}
      });
    });

    /* Restore dismissed state across navigations */
    document.querySelectorAll('[id^="announcement-bar-"]').forEach(function (bar) {
      var id = bar.id.replace('announcement-bar-', '');
      if (sessionStorage.getItem('yc-bar-dismissed-' + id)) bar.remove();
    });
  }

  function initCountdowns() {
    function tick() {
      document.querySelectorAll('.ab-countdown[data-end]').forEach(function (el) {
        var end  = new Date(el.dataset.end).getTime();
        var now  = Date.now();
        var diff = end - now;

        if (diff <= 0) {
          el.textContent = YCT('countdown_over');
          return;
        }
        var d  = Math.floor(diff / 86400000);
        var h  = Math.floor((diff % 86400000) / 3600000);
        var m  = Math.floor((diff % 3600000)  / 60000);
        var s  = Math.floor((diff % 60000)    / 1000);

        var dEl = el.querySelector('[data-cd-days]');
        var hEl = el.querySelector('[data-cd-hours]');
        var mEl = el.querySelector('[data-cd-min]');
        var sEl = el.querySelector('[data-cd-sec]');

        if (dEl) dEl.textContent = d;
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');
      });
    }
    if (document.querySelector('.ab-countdown')) {
      tick();
      setInterval(tick, 1000);
    }
  }

  /* ----------------------------------------------------------------
     CTA FLOTTANT MOBILE
     Apparaît après 300px de scroll. Disparaît si l'utilisateur ferme.
  ---------------------------------------------------------------- */
  function initStickyMobileCta() {
    var cta   = document.getElementById('cta-sticky-mobile');
    var close = cta && cta.querySelector('.cta-sticky-close');
    if (!cta) return;

    if (sessionStorage.getItem('yc-cta-dismissed')) return;

    var shown    = false;
    var ticking  = false;

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        if (!shown && window.scrollY > 300) {
          shown = true;
          cta.setAttribute('aria-hidden', 'false');
          cta.classList.add('is-visible');
        }
        ticking = false;
      });
    }, { passive: true });

    close && close.addEventListener('click', function () {
      cta.classList.remove('is-visible');
      cta.setAttribute('aria-hidden', 'true');
      try { sessionStorage.setItem('yc-cta-dismissed', '1'); } catch (e) {}
    });
  }

  /* ----------------------------------------------------------------
     VIDÉO LAZY — click-to-play sur le poster
  ---------------------------------------------------------------- */
  function initVideoShowcase() {
    document.querySelectorAll('.video-showcase__poster').forEach(function (poster) {
      poster.addEventListener('click', function () {
        var url   = this.dataset.videoUrl;
        var frame = this.closest('.video-showcase__ratio').querySelector('.video-showcase__frame');
        if (!url || !frame) return;

        /* YouTube — ajouter autoplay=1 */
        if (url.includes('youtube.com') || url.includes('youtu.be')) {
          url += (url.includes('?') ? '&' : '?') + 'autoplay=1&rel=0';
        }

        frame.innerHTML = '<iframe src="' + url + '" allow="autoplay; fullscreen" allowfullscreen loading="lazy"></iframe>';
        frame.setAttribute('aria-hidden', 'false');
        this.classList.add('is-hidden');
      });
    });
  }

  /* ----------------------------------------------------------------
     TOGGLE JOUR / NUIT
     Lit localStorage + préférence système au premier chargement.
     Le script inline dans <head> applique déjà le bon thème avant
     le rendu pour éviter le flash (FOUC).
  ---------------------------------------------------------------- */
  function initThemeToggle() {
    var btn  = document.querySelector('.theme-toggle');
    var root = document.documentElement;
    if (!btn) return;

    btn.addEventListener('click', function () {
      var current = root.getAttribute('data-theme') || 'dark';
      var next    = current === 'dark' ? 'light' : 'dark';
      root.setAttribute('data-theme', next);
      localStorage.setItem('yc-theme', next);
    });
  }

  /* ----------------------------------------------------------------
     GALERIE PRODUIT — clic sur thumbnail → change l'image principale
  ---------------------------------------------------------------- */
  function initProductGallery() {
    document.querySelectorAll('.yc-gallery-thumbs').forEach(function (strip) {
      var thumbs = Array.from(strip.querySelectorAll('.yc-thumb'));

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var targetId = this.dataset.target;
          var mainImg  = document.getElementById(targetId);
          if (!mainImg) return;

          /* Mise à jour srcset + src */
          var src450  = this.dataset.src450;
          var src900  = this.dataset.src900;
          var src1200 = this.dataset.src1200;
          var alt     = this.dataset.alt || '';

          mainImg.src = src900;
          if (src450 && src900 && src1200) {
            mainImg.srcset = src450 + ' 450w, ' + src900 + ' 900w, ' + src1200 + ' 1200w';
          }
          mainImg.alt = alt;

          /* Actif */
          thumbs.forEach(function (t) { t.classList.remove('yc-thumb--active'); });
          this.classList.add('yc-thumb--active');
        });
      });
    });
  }

  /* ----------------------------------------------------------------
     SÉLECTEUR DE VARIANTES — boutons option → trouve la variante
     correspondante → met à jour prix / ATC / image / id hidden input
  ---------------------------------------------------------------- */
  function initVariantPicker() {
    document.querySelectorAll('.yc-variant-picker').forEach(function (picker) {
      var sectionId   = picker.dataset.section;
      var variantsEl  = document.getElementById('yc-variants-data-' + sectionId);
      var imagesEl    = document.getElementById('yc-product-images-' + sectionId);
      if (!variantsEl) return;

      var variants    = JSON.parse(variantsEl.textContent);
      var images      = imagesEl ? JSON.parse(imagesEl.textContent) : [];
      var optionGroups = Array.from(picker.querySelectorAll('.yc-option-btns'));

      /* État courant : une valeur sélectionnée par groupe */
      var selectedValues = optionGroups.map(function (group) {
        var active = group.querySelector('.yc-opt-btn--active');
        return active ? active.dataset.value : '';
      });

      /* Trouve la variante qui correspond aux options sélectionnées */
      function findVariant() {
        return variants.find(function (v) {
          return selectedValues.every(function (val, i) {
            return v['option' + (i + 1)] === val;
          });
        }) || null;
      }

      /* Met à jour les prix, le bouton ATC, l'id hidden, le sticky */
      function applyVariant(variant) {
        if (!variant) return;

        /* Nom du format Shopify → money (approximation sans API) */
        function formatMoney(cents) {
          return (cents / 100).toLocaleString(YC_MONEY_LOCALE, {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2
          });
        }

        /* Prix courant */
        var priceEl   = document.getElementById('yc-price-current-' + sectionId);
        var compareEl = document.getElementById('yc-price-compare-' + sectionId);
        var saveEl    = document.getElementById('yc-price-save-' + sectionId);

        if (priceEl)   priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.style.display = '';
            if (saveEl) {
              var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
              saveEl.textContent = '-' + pct + '%';
              saveEl.style.display = '';
            }
          } else {
            compareEl.style.display = 'none';
            if (saveEl) saveEl.style.display = 'none';
          }
        }

        /* Sticky price */
        var stickyPrice = document.getElementById('yc-sticky-price-' + sectionId);
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

        /* Hidden input + bouton ATC */
        var hiddenInput = document.getElementById('yc-variant-id-' + sectionId);
        var atcBtn      = document.getElementById('yc-atc-' + sectionId);
        var atcLabel    = document.getElementById('yc-atc-label-' + sectionId);
        var stickyBtn   = document.getElementById('sticky-atc-trigger-' + sectionId);

        if (hiddenInput) hiddenInput.value = variant.id;

        var available = variant.available;
        if (atcBtn) {
          atcBtn.disabled = !available;
          if (atcLabel) atcLabel.textContent = available ? YCT('add_to_cart') : YCT('sold_out');
        }
        if (stickyBtn) {
          stickyBtn.disabled = !available;
          stickyBtn.textContent = available ? YCT('add_short') : YCT('sold_out');
        }

        /* Image variante — change la principale si la variante a une image */
        if (variant.featured_image) {
          var varImgId = variant.featured_image.id;
          var imgData  = images.find(function (img) { return img.id === varImgId; });
          if (imgData) {
            var mainImg = document.getElementById('yc-main-img-' + sectionId);
            if (mainImg) {
              mainImg.src    = imgData.src_900;
              mainImg.srcset = imgData.src_450 + ' 450w, ' + imgData.src_900 + ' 900w, ' + imgData.src_1200 + ' 1200w';
              mainImg.alt    = imgData.alt;
            }
            /* Activer le bon thumbnail */
            var thumbs = picker.closest('.yc-product-layout')
              ? picker.closest('.yc-product-layout').querySelectorAll('.yc-thumb')
              : [];
            thumbs.forEach(function (t) {
              t.classList.remove('yc-thumb--active');
              if (t.dataset.src900 === imgData.src_900) t.classList.add('yc-thumb--active');
            });
          }
        }
      }

      /* Attache les clics sur chaque groupe d'options */
      optionGroups.forEach(function (group, groupIndex) {
        var btns = Array.from(group.querySelectorAll('.yc-opt-btn'));

        btns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            /* Mise à jour active dans le groupe */
            btns.forEach(function (b) {
              b.classList.remove('yc-opt-btn--active');
              b.setAttribute('aria-pressed', 'false');
            });
            this.classList.add('yc-opt-btn--active');
            this.setAttribute('aria-pressed', 'true');

            selectedValues[groupIndex] = this.dataset.value;

            /* Mise à jour du libellé ": Valeur" */
            var valLabel = document.getElementById('yc-opt-val-' + sectionId + '-' + groupIndex);
            if (valLabel) valLabel.textContent = ': ' + this.dataset.value;

            /* Applique la variante trouvée */
            var variant = findVariant();
            if (variant) applyVariant(variant);
          });
        });
      });

      /* Lier le sticky ATC au submit du vrai formulaire */
      var stickyBtn = document.getElementById('sticky-atc-trigger-' + sectionId);
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var atcBtn = document.getElementById('yc-atc-' + sectionId);
          if (atcBtn && !atcBtn.disabled) atcBtn.click();
        });
      }
    });
  }

  /* ----------------------------------------------------------------
     SÉLECTEUR DE QUANTITÉ — boutons +/–
  ---------------------------------------------------------------- */
  function initQtySelectors() {
    document.querySelectorAll('.yc-qty-selector').forEach(function (sel) {
      var input   = sel.querySelector('.yc-qty-input');
      var btnMinus = sel.querySelector('[data-action="minus"]');
      var btnPlus  = sel.querySelector('[data-action="plus"]');
      if (!input) return;

      function update(delta) {
        var val = parseInt(input.value, 10) || 1;
        var min = parseInt(input.min, 10) || 1;
        input.value = Math.max(min, val + delta);
      }

      btnMinus && btnMinus.addEventListener('click', function () { update(-1); });
      btnPlus  && btnPlus.addEventListener('click',  function () { update(1);  });
    });
  }

  /* ----------------------------------------------------------------
     ACCORDÉONS PRODUIT
  ---------------------------------------------------------------- */
  function initProductAccordions() {
    document.querySelectorAll('.yc-accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        var body     = this.nextElementSibling;
        if (!body) return;
        this.setAttribute('aria-expanded', String(!expanded));
        body.hidden = expanded;
      });
    });
  }

  /* ----------------------------------------------------------------
     ACCORDÉON FAQ
     Un seul item ouvert à la fois (referme les autres).
  ---------------------------------------------------------------- */
  function initFaqAccordion() {
    document.querySelectorAll('.yc-faq-list').forEach(function (list) {
      var triggers = Array.from(list.querySelectorAll('.yc-faq-q'));

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var isOpen  = this.getAttribute('aria-expanded') === 'true';
          var bodyId  = this.getAttribute('aria-controls');
          var body    = bodyId ? document.getElementById(bodyId) : this.nextElementSibling;

          /* Ferme tous les items du groupe */
          triggers.forEach(function (t) {
            t.setAttribute('aria-expanded', 'false');
            var b = document.getElementById(t.getAttribute('aria-controls'));
            if (b) b.hidden = true;
          });

          /* Ouvre celui-ci si c'était fermé */
          if (!isOpen) {
            this.setAttribute('aria-expanded', 'true');
            if (body) body.hidden = false;
          }
        });
      });
    });
  }

  /* ----------------------------------------------------------------
     CART DRAWER — panneau latéral AJAX
     • Slide depuis la droite
     • Items, qtés +/–, suppression via /cart/change.js
     • Intercepte les formulaires ATC pour éviter le rechargement
     • Barre de progression livraison offerte dès 199€
  ---------------------------------------------------------------- */
  function initCartDrawer() {
    var drawer   = document.getElementById('yc-cart-drawer');
    if (!drawer) return;

    var itemsList    = document.getElementById('yc-cart-items');
    var emptyEl      = document.getElementById('yc-cart-empty');
    var footerEl     = document.getElementById('yc-cart-footer');
    var countEl      = drawer.querySelector('.yc-cart-drawer__count');
    var totalEl      = document.getElementById('yc-cart-total');
    var fillEl       = document.getElementById('yc-shipping-fill');
    var msgEl        = document.getElementById('yc-shipping-msg');
    var checkoutBtn  = document.getElementById('ycd-checkout-btn');
    var headerCounts = document.querySelectorAll('.cart-count');
    var FREE_THRESHOLD = 19900; /* 199,00€ en centimes */

    /* ── Cache inventaire (variant_id → quantité en stock) ──
       Alimenté par les <script type="application/json"> injectés en Liquid.
       Défaut : 999 = pas de limite connue → afficher les contrôles. */
    var inventoryCache = {};
    function buildInventoryCache() {
      var sources = [document.getElementById('yc-inventory-cache')]
        .concat(Array.from(document.querySelectorAll('.yc-product-inventory')));
      sources.forEach(function(el) {
        if (!el) return;
        try { Object.assign(inventoryCache, JSON.parse(el.textContent)); } catch(e) {}
      });
    }
    buildInventoryCache();

    /* ── Ouvrir / fermer ──
       L'attribut hidden est le filet de sécurité si le CSS n'est pas
       chargé : un tiroir fermé reste invisible (display:none natif).
       Le timer est annulé à chaque ouverture pour éviter tout état
       incohérent en cas d'ouverture/fermeture rapprochées. */
    var drawerHideTimer = null;
    function openDrawer() {
      clearTimeout(drawerHideTimer);
      drawer.removeAttribute('hidden');
      drawer.setAttribute('aria-hidden', 'false');
      void drawer.offsetWidth; /* reflow : transition depuis l'état fermé */
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      loadCart();
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      clearTimeout(drawerHideTimer);
      drawerHideTimer = setTimeout(function() { drawer.setAttribute('hidden', ''); }, 400);
    }

    /* Fermeture : overlay + bouton × (éléments statiques) */
    var overlay  = drawer.querySelector('.yc-cart-drawer__overlay');
    var closeBtn = drawer.querySelector('.yc-cart-drawer__close');
    if (overlay)  overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    /* Ouverture : bouton panier dans le header */
    document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function(btn) {
      btn.addEventListener('click', openDrawer);
    });

    /* ── Event delegation sur la liste d'items ──
       Un seul listener sur le <ul>, survit aux rebuilds innerHTML.
       Les boutons +/– et × sont recréés à chaque renderCart :
       on ne leur attache PLUS de listeners individuels. */
    if (itemsList) {
      itemsList.addEventListener('click', function(e) {
        var qtyBtn    = e.target.closest('.yc-cart-item__qty-btn');
        var removeBtn = e.target.closest('.yc-cart-item__remove');

        if (qtyBtn) {
          var li      = qtyBtn.closest('.yc-cart-item');
          var itemKey = li.dataset.itemKey;          /* line item key "variantId:hash" */
          var qtyEl   = li.querySelector('.yc-cart-item__qty-val');
          var current = parseInt(qtyEl.textContent, 10);
          var delta   = qtyBtn.dataset.action === 'plus' ? 1 : -1;
          changeItem(itemKey, Math.max(0, current + delta));
        }

        if (removeBtn) {
          changeItem(removeBtn.dataset.itemKey, 0);
        }
      });
    }

    /* ── Format monétaire ── */
    function fmt(cents) {
      return (cents / 100).toLocaleString(YC_MONEY_LOCALE, {
        style: 'currency', currency: 'EUR', minimumFractionDigits: 2
      });
    }

    /* ── Barre livraison offerte ── */
    function updateShippingBar(totalCents) {
      if (!fillEl || !msgEl) return;
      var pct = Math.min(100, (totalCents / FREE_THRESHOLD) * 100);
      fillEl.style.width = pct + '%';
      if (totalCents >= FREE_THRESHOLD) {
        msgEl.innerHTML = YCT('free_ship_ok');
        fillEl.style.background = '#22c55e';
      } else {
        var reste = fmt(FREE_THRESHOLD - totalCents);
        msgEl.innerHTML = YCT('free_ship_left', { n: reste });
        fillEl.style.background = '';
      }
    }

    /* ── Mettre à jour les compteurs header ── */
    function updateHeaderCount(count) {
      headerCounts.forEach(function(el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
      if (countEl) countEl.textContent = count > 0 ? '(' + count + ')' : '';
    }

    /* ── Rendre les items du panier ── */
    function renderCart(cart) {
      updateHeaderCount(cart.item_count);
      if (totalEl) totalEl.textContent = fmt(cart.total_price);
      updateShippingBar(cart.total_price);

      if (cart.item_count === 0) {
        if (emptyEl)   emptyEl.hidden  = false;
        if (footerEl)  footerEl.hidden = true;
        if (itemsList) itemsList.innerHTML = '';
        return;
      }

      if (emptyEl)  emptyEl.hidden  = true;
      if (footerEl) footerEl.hidden = false;

      var html = cart.items.map(function(item) {
        var raw = item.image || '';
        var img = raw
          ? '<a href="' + item.url + '" class="yc-cart-item__img-link" data-cart-close>' +
            '<img src="' + raw.replace(/(\.[a-z]+)(\?|$)/, '_120x120$1$2') + '" alt="" ' +
            'class="yc-cart-item__img" loading="lazy" width="80" height="80"></a>'
          : '<div class="yc-cart-item__img-link yc-cart-item__img-link--empty"></div>';

        var variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<span class="yc-cart-item__variant">' + item.variant_title + '</span>'
          : '';

        /* Quantité : contrôle uniquement si stock > 1 */
        var inv      = inventoryCache[item.variant_id];
        var stock    = (inv !== undefined) ? parseInt(inv, 10) : 999;
        var qtyHtml  = stock > 1
          ? '<div class="yc-cart-item__qty">' +
              '<button class="yc-cart-item__qty-btn" data-action="minus" aria-label="' + YCT('qty_minus') + '">−</button>' +
              '<span class="yc-cart-item__qty-val">' + item.quantity + '</span>' +
              '<button class="yc-cart-item__qty-btn" data-action="plus" aria-label="' + YCT('qty_plus') + '">+</button>' +
            '</div>'
          : '<div class="yc-cart-item__qty-fixed">×' + item.quantity + '</div>';

        return [
          '<li class="yc-cart-item" data-item-key="' + item.key + '">',
            img,
            /* Colonne info */
            '<div class="yc-cart-item__info">',
              '<a href="' + item.url + '" class="yc-cart-item__name" data-cart-close>' + item.product_title + '</a>',
              variant,
              '<span class="yc-cart-item__price">' + fmt(item.final_line_price) + '</span>',
            '</div>',
            /* Colonne actions : qty en haut, Retirer en bas */
            '<div class="yc-cart-item__actions">',
              qtyHtml,
              '<button class="yc-cart-item__remove" data-item-key="' + item.key + '" aria-label="' + YCT('remove') + '">' + YCT('remove') + '</button>',
            '</div>',
          '</li>'
        ].join('');
      }).join('');

      /* Les listeners +/– et × sont gérés par event delegation (voir plus haut) */
      if (itemsList) {
        itemsList.innerHTML = html;
      }
    }

    /* ── Charger le panier via AJAX ── */
    function loadCart() {
      fetch(YC_ROOT + 'cart.js')
        .then(function(r) { return r.json(); })
        .then(renderCart)
        .catch(function() {});
    }

    /* ── Modifier la quantité d'un item ── */
    function changeItem(variantId, qty) {
      fetch(YC_ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function() { loadCart(); }) /* refetch /cart.js — source de vérité fiable */
      .catch(function() { loadCart(); });
    }

    /* ── Intercepter tous les formulaires ATC ── */
    document.addEventListener('submit', function(e) {
      var form   = e.target;
      var action = (form.getAttribute('action') || '');
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();

      var submitBtn = form.querySelector('[name="add"]');
      if (submitBtn) { submitBtn.disabled = true; }

      fetch(YC_ROOT + 'cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function(r) { return r.json(); })
        .then(function() { openDrawer(); })
        .catch(function() {})
        .finally(function() {
          if (submitBtn) { submitBtn.disabled = false; }
        });
    }, true); /* capture = true pour être avant le submit natif */

    /* ── Initialisation : compteur header au chargement ── */
    fetch(YC_ROOT + 'cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateHeaderCount(cart.item_count);
        updateShippingBar(cart.total_price);
      })
      .catch(function() {});
  }

  /* ----------------------------------------------------------------
     POPUP FICHE TECHNIQUE
     Bouton "Voir la fiche technique" → popup slide-up
  ---------------------------------------------------------------- */
  function initSpecsPopup() {
    /* Ouvrir */
    document.querySelectorAll('[data-specs-open]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id  = this.dataset.specsOpen;
        var pop = document.getElementById('yc-specs-popup-' + id);
        if (!pop) return;
        pop.setAttribute('aria-hidden', 'false');
        pop.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        var firstClose = pop.querySelector('[data-specs-close]');
        if (firstClose) setTimeout(function() { firstClose.focus(); }, 50);
      });
    });

    /* Fermer */
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-specs-close]')) {
        var pop = e.target.closest('.yc-specs-popup');
        if (pop) {
          pop.classList.remove('is-open');
          pop.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.yc-specs-popup.is-open').forEach(function(pop) {
        pop.classList.remove('is-open');
        pop.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
  }

  /* ----------------------------------------------------------------
     TABS CART DRAWER — Notes / Livraison / Réduction
  ---------------------------------------------------------------- */
  function initCartDrawerTabs() {
    var tabBtns   = document.querySelectorAll('.ycd-tabs__btn');
    var panels    = document.querySelectorAll('.ycd-tabs__panel');

    /* Toggle d'un tab : clic ferme si déjà ouvert */
    tabBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var targetId = this.getAttribute('aria-controls');
        var panel    = document.getElementById(targetId);
        var isOpen   = this.getAttribute('aria-selected') === 'true';

        /* Fermer tous */
        tabBtns.forEach(function(b) { b.setAttribute('aria-selected', 'false'); b.classList.remove('is-active'); });
        panels.forEach(function(p) { p.hidden = true; });

        /* Ouvrir celui-ci si c'était fermé */
        if (!isOpen && panel) {
          this.setAttribute('aria-selected', 'true');
          this.classList.add('is-active');
          panel.hidden = false;
          /* Focus sur l'input si présent */
          var inp = panel.querySelector('textarea, input');
          if (inp) setTimeout(function() { inp.focus(); }, 50);
        }
      });
    });

    /* Note de commande — enregistrer via /cart/update.js */
    var noteSave  = document.getElementById('ycd-note-save');
    var noteInput = document.getElementById('ycd-cart-note');
    var noteOk    = document.getElementById('ycd-note-saved');
    if (noteSave && noteInput) {
      noteSave.addEventListener('click', function() {
        fetch(YC_ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteInput.value })
        })
        .then(function() {
          if (noteOk) { noteOk.hidden = false; setTimeout(function() { noteOk.hidden = true; }, 2500); }
        })
        .catch(function() {});
      });
    }

    /* Code promo — redirige vers /checkout?discount=CODE */
    var discountApply = document.getElementById('ycd-discount-apply');
    var discountInput = document.getElementById('ycd-discount-input');
    if (discountApply && discountInput) {
      discountApply.addEventListener('click', function() {
        var code = discountInput.value.trim();
        if (!code) { discountInput.focus(); return; }
        window.location.href = YC_ROOT + 'checkout?discount=' + encodeURIComponent(code);
      });
      discountInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') discountApply.click();
      });
    }
  }

  /* ----------------------------------------------------------------
     FORMULAIRE "ME PRÉVENIR" — back-in-stock
     Soumet via /contact (Shopify built-in) en AJAX.
     Le marchand reçoit l'email du client + le produit concerné.
  ---------------------------------------------------------------- */
  function initNotifyForm() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-notify-submit]');
      if (!btn) return;

      var sid     = btn.dataset.notifySubmit;
      var emailEl = document.getElementById('yc-notify-email-' + sid);
      var okEl    = document.getElementById('yc-notify-ok-' + sid);
      if (!emailEl) return;

      var email = emailEl.value.trim();
      if (!email || !email.includes('@')) {
        emailEl.focus();
        emailEl.classList.add('yc-notify-form__input--error');
        setTimeout(function() { emailEl.classList.remove('yc-notify-form__input--error'); }, 1200);
        return;
      }

      var product = btn.dataset.product || '';
      var variant = btn.dataset.variant || '';
      var url     = btn.dataset.url || '';

      var body  = 'form_type=contact&utf8=✓';
      body += '&contact[email]=' + encodeURIComponent(email);
      body += '&contact[subject]=' + encodeURIComponent('Me prévenir — ' + product + (variant && variant !== 'Default Title' ? ' (' + variant + ')' : ''));
      body += '&contact[body]=' + encodeURIComponent('Je veux être prévenu(e) quand ce produit est de retour :\n' + product + (variant && variant !== 'Default Title' ? ' — ' + variant : '') + '\n' + url);

      btn.disabled = true;

      fetch(YC_ROOT + 'contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      })
      .then(function() {
        emailEl.style.display = 'none';
        btn.style.display = 'none';
        if (okEl) okEl.hidden = false;
      })
      .catch(function() {
        btn.disabled = false;
      });
    });
  }

  /* ----------------------------------------------------------------
     SCROLL REVEAL
     IntersectionObserver → fade-in + slide-up au défilement.
     Les cartes dans un même parent sont décalées (stagger).
  ---------------------------------------------------------------- */
  function initGradePopup() {
    var popup = document.getElementById('yc-grade-popup');
    if (!popup) return;

    function openPopup(grade) {
      var entries    = popup.querySelectorAll('[data-grade-entry]');
      var seps       = popup.querySelectorAll('.yc-grade-separator');
      var letterEl   = popup.querySelector('#yc-grade-popup-letter');
      var titleEl    = popup.querySelector('#yc-grade-popup-title');

      if (grade) {
        entries.forEach(function(el) {
          el.style.display = el.getAttribute('data-grade-entry') === grade ? '' : 'none';
        });
        seps.forEach(function(el) { el.style.display = 'none'; });
        if (letterEl) letterEl.textContent = grade;
      } else {
        entries.forEach(function(el) { el.style.display = ''; });
        seps.forEach(function(el) { el.style.display = ''; });
        if (letterEl) letterEl.textContent = YCT('all_grades');
      }

      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = popup.querySelector('[data-grade-close]');
      if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 50);
    }

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    /* Ouvrir via badge — lit le grade dans data-grade-open */
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-grade-open]');
      if (btn) {
        e.preventDefault();
        var grade = btn.getAttribute('data-grade-open') || null;
        openPopup(grade);
      }
    });

    /* Fermer via overlay ou bouton × */
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-grade-close]')) closePopup();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });
  }

  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;

    /* Sélecteurs ciblés — headings, cartes, grilles */
    var BLOCK_SELECTORS = [
      '.featured-console-card',
      '.reassurance-item',
      '.filter-card',
      '.yc-insta-item',
      '.yc-page-card',
      '.yc-trust-item',
      '.yc-about__value-card',
      '.yc-about__stat',
      '.yc-faq-item',
    ].join(', ');

    var SINGLE_SELECTORS = [
      '.yc-section-title',
      '.yc-insta-title',
      '.yc-insta-sub',
      '.section-title',
      '.ba-container',
      '.yc-product-layout',
      '.yc-contact-grid',
    ].join(', ');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('yc-revealed');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.10, rootMargin: '0px 0px -32px 0px' });

    /* Cartes : stagger au sein de leur parent */
    document.querySelectorAll(BLOCK_SELECTORS).forEach(function (el) {
      var siblings = Array.from(el.parentElement.children).filter(function (c) {
        return c.matches(BLOCK_SELECTORS);
      });
      var idx = siblings.indexOf(el);
      el.style.setProperty('--yc-reveal-delay', Math.min(idx, 5) * 70 + 'ms');
      el.classList.add('yc-will-reveal');
      observer.observe(el);
    });

    /* Éléments uniques : pas de stagger */
    document.querySelectorAll(SINGLE_SELECTORS).forEach(function (el) {
      if (el.classList.contains('yc-will-reveal')) return;
      el.style.setProperty('--yc-reveal-delay', '0ms');
      el.classList.add('yc-will-reveal');
      observer.observe(el);
    });
  }

  /* ----------------------------------------------------------------
     INIT — attend le DOM si nécessaire
  ---------------------------------------------------------------- */
  /* ----------------------------------------------------------------
     SÉLECTEUR DE LANGUE
  ---------------------------------------------------------------- */
  function initLangSelector() {
    var trigger  = document.getElementById('header-lang-trigger');
    var dropdown = document.querySelector('.header-lang-dropdown');
    if (!trigger || !dropdown) return;

    /* Réécrit les liens de langue pour conserver la page courante en
       changeant de langue/marché (préfixes de sous-dossier Shopify). */
    (function rewriteLangLinks() {
      var opts = dropdown.querySelectorAll('a[data-lang-prefix]');
      if (!opts.length) return;
      // Préfixes de tous les marchés (le plus long d'abord) à retirer du chemin.
      var prefixes = [
        '/en-us', '/es-us', '/fr-us',
        '/fr-eu', '/de-eu', '/en-eu', '/es-eu', '/it-eu', '/nl-eu', '/pt-eu', '/ru-eu',
        '/en-global', '/de-global', '/es-global', '/fr-global', '/pt-global', '/ru-global', '/zh-global',
        '/en'
      ];
      var path = window.location.pathname;
      var bare = path;
      for (var i = 0; i < prefixes.length; i++) {
        var pre = prefixes[i];
        if (path === pre) { bare = '/'; break; }
        if (path.indexOf(pre + '/') === 0) { bare = path.slice(pre.length); break; }
      }
      var search = window.location.search || '';
      opts.forEach(function (a) {
        var pre = a.getAttribute('data-lang-prefix') || '';
        var target = pre + bare;
        if (target === '') target = '/';
        a.setAttribute('href', target + search);
      });
    })();

    var siteHeader = trigger.closest('.site-header');
    function open() {
      dropdown.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      if (siteHeader) siteHeader.classList.add('header-lang-open');
    }
    function close() {
      dropdown.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (siteHeader) siteHeader.classList.remove('header-lang-open');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      dropdown.hidden ? open() : close();
    });

    document.addEventListener('click', function (e) {
      if (!trigger.contains(e.target) && !dropdown.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !dropdown.hidden) close();
    });
  }

  function init() {
    initMobileMenu();
    initLangSelector();
    initBeforeAfterSliders();
    initConsoleFilter();
    initStickyHeader();
    initThemeToggle();
    initAnnouncementBar();
    initCountdowns();
    initStickyMobileCta();
    initVideoShowcase();
    initProductUrgency();
    initNewsletterPopup();
    initProductGallery();
    initVariantPicker();
    initQtySelectors();
    initProductAccordions();
    initFaqAccordion();
    initSpecsPopup();
    initGradePopup();
    initCartDrawer();
    initCartDrawerTabs();
    initNotifyForm();
    initScrollReveal();
    initSortSoldOut();
  }

  /* ----------------------------------------------------------------
     TRI PRODUITS ÉPUISÉS — les repousser en fin de grille
     - yc-collection.liquid  : yc-card--soldout sur <li>
     - card-product.liquid   : yc-card--soldout sur <div> dans <li.grid__item>
  ---------------------------------------------------------------- */
  function initSortSoldOut() {
    var soldOut = document.querySelectorAll('.yc-card--soldout');
    if (!soldOut.length) return;

    var parentMap = new Map();
    soldOut.forEach(function (card) {
      /* Si la classe est directement sur un <li> (yc-collection), c'est lui l'item.
         Sinon remonter au <li> ancêtre (grille Dawn standard). */
      var item = (card.tagName === 'LI') ? card : (card.closest('li') || card);
      var parent = item.parentElement;
      if (!parent) return;
      if (!parentMap.has(parent)) parentMap.set(parent, []);
      var list = parentMap.get(parent);
      if (list.indexOf(item) === -1) list.push(item);
    });

    parentMap.forEach(function (items, parent) {
      items.forEach(function (item) { parent.appendChild(item); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
